<template>
  <div id="user-manage">
    <!--搜索-->
    <div class="top">
    <el-col :span="12">
        <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :span="2" :offset="1">
      <el-button type="primary" size="small" @click="AddModal">新增股票</el-button>
       </el-col>
    </div>
    <!--表格-->
    <div class="user-table">
      <el-table border :data="tableData">
        <el-table-column label="股票 ID" align="center" width="300" prop="id"></el-table-column>
        <el-table-column
          label="股票名称"
          align="center"
          width="300"
          show-overflow-tooltip
          prop="name"
        ></el-table-column>


        <el-table-column label="股票代码" align="center" width="300" prop="stock"></el-table-column>

        <el-table-column align="center" width="300" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="EditModal(scope.row)">编辑股票</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total"
      ></el-pagination>
    </div>

  <!--查看详情-->
    <el-dialog
        title="查看详情"
        :visible.sync="addDialogFormVisible"
        :modal-append-to-body="false"
        v-if="addDialogFormVisible"
        :show-close="false"
      >
    <el-table border :data="dialogTableData">
      <el-table-column label="股票名称" width="250" prop="name"></el-table-column>
      <el-table-column label="股票代码" show-overflow-tooltip prop="stock"></el-table-column>
    </el-table>
    </el-dialog>

  <!--修改分组信息-->
  <!--弹框-->
  <div>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="addDialogEditFormVisible"
        :modal-append-to-body="false"
        v-if="addDialogEditFormVisible"
        :showClose="false"
      >
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="bannerInfo">



          <el-form-item label="股票名称" prop="firstTitle">
            <el-col :span="16">
              <el-input v-model="bannerInfo.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="股票代码" prop="firstTitle" >
            <el-col :span="16">
              <el-input v-model="bannerInfo.stock"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="manageBannerInfo()">确 定</el-button>
        </div>
      </el-dialog>
    </div>



  </div>
</template>
<script>
import {
  getUserAuthInfo,
  getGroup,
  updateUserAuthInfo, updateStockInfo, addStockInfo
} from "../../../api/index";
import { MessageBox, Message } from "element-ui";
export default {
  name: "UserManage",
  data() {

    return {
      //服务器地址
      tableData: [],
      dialogTableData: [],
      dialogEditTableData: [],
      total: 0,
      currentPage: 1,
      userInfo: {},
      bannerInfo: {},
      dialogFormVisible: false,
      dialogVisible: false,
      dialogTitle: "",
      user_id: "",
      searchInput: "",
      input: "",
      module_name: "",
      selectedRow: null,
      labelPosition: "right",
      addDialogFormVisible: false,
      addDialogEditFormVisible: false
    };
  },
  created() {
    this.getUserAuthInfo(this.currentPage, 8,'');
  },
  methods: {
    async loadOptions(row,edit){

            let json = await getGroup(row,edit);
            if (json.code==='200'){
              this.xd = ''

              this.xk = ''

              this.nj = ''
              this.module_name = ''


              this.dialogTableData = json.data;
              this.dialogEditTableData = json.data;
            }
          },

    async openModal(row) {
      this.loadOptions(row.group,'see');
      this.addDialogFormVisible = true;
    },

    async EditModal(row) {
      this.bannerInfo = row
      this.dialogTitle = '编辑股票信息'
      this.addDialogEditFormVisible = true;
    },

    async AddModal() {
      this.bannerInfo = {}
      this.dialogTitle = '新增股票信息'
      this.addDialogEditFormVisible = true;
    },

    async closeModal() {
      this.dialogVisible = false;

    },

    async getUserAuthInfo(currentPage, pageSize,searchInput) {
      let json = await getUserAuthInfo(currentPage, pageSize,searchInput);
      if (json.code === 200) {
        this.tableData = json.data;
        this.total = Math.ceil(json.total / 10);
      }
    },

    async handleAction(row,user_id) {
      MessageBox.confirm('此操作将修改该用户观看权限, 是否继续？','提示').then(async (value)=>{
        if (value==='confirm'){
          let json = await updateUserAuthInfo(row.id,row.status,user_id);
          if (json.code==='200'){
            this.getUserAuthInfo(this.currentPage,8,'');
            Message.success('更改成功');
          }
        }
      });


    },

    async manageBannerInfo(){
               if (this.dialogTitle==='编辑股票信息'){
              this.stock  = this.bannerInfo.stock;
              if (this.stock) {
                let json = await updateStockInfo(this.bannerInfo);
                if (json.code===200){
                  this.addDialogEditFormVisible = false;
                  Message.success('修改股票信息成功！');
                } else{
                  Message.error(json.msg);
                }
              } else{
                Message.error('请完成必填内容！');
                }
               }
               else {
              this.stock  = this.bannerInfo.stock;
              if (this.stock) {
                let json = await addStockInfo(this.bannerInfo);
                if (json.code===200){
                  this.addDialogEditFormVisible = false;
                  Message.success('新增股票信息成功！');
                } else{
                  Message.error(json.msg);
                }
              } else{
                Message.error('请完成必填内容！');
                }
               }

              this.getUserAuthInfo(1,8,'');

        },

    async currentChange(currentPage) {
  this.currentPage = currentPage;
  this.getUserAuthInfo(this.currentPage, 8,'');
},

    formatBoolean: function (row, column, cellValue) {
      var ret = ''  //你想在页面展示的值
      if (cellValue) {
        ret = "是"  //根据自己的需求设定
      } else {
        ret = "否"
      }
      return ret;
    },

    search() {
      this.searchInput = this.input;
      this.getUserAuthInfo(1, 8, this.searchInput);
    },

    cancel() {
      this.getUserAuthInfo(this.currentPage, 8, this.searchInput);
      this.addDialogEditFormVisible = false;
    },


  }
};
</script>

<style scoped>
.user-table {
  width: 90%;
  min-width: 900px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 30px 0; */
  margin-bottom: 30px;
}
.block {
  text-align: center;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body .el-form-item {
  padding-left: 20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/HallManage.vue